import React, {Component} from 'react';
import {connect} from 'react-redux';
import {dash_action_logged} from '../../store/actions/admin';

import LogRocket from 'logrocket';
import swal from 'sweetalert';

import {
    FormGroup,
    TextInput,
    Grid,
    Row,
    Column,
    Button,
    ComposedModal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "carbon-components-react"
import {ChevronRight24} from "@carbon/icons-react"

import "./index.scss"
import {ReactComponent as K_SVG} from "./assets/K_SVG.svg"
import data from "../../data"
import {Auth} from 'aws-amplify';

let bgStyle = {
    background: "transparent linear-gradient(180deg, " + process.env.REACT_APP_BG_COLOR_CLIENT1 + " 0%, " + process.env.REACT_APP_BG_COLOR_CLIENT2 + " 100%) 0% 0% no-repeat padding-box",
};
const reg = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\\w\\s]).{8,}$");

class Recovery extends Component {
    state = {
        form: {
            code: '',
            login: '',
            pass: '',
            newpass: '',
            confirm: ''
        },
        isLoading: false,
        showAlert: false,
        setPassword: false,
        user: null,
        validPass: true,
        validDifPass: false,
        forgetPass: false,
        successNewPass: false
    };

    async componentDidMount() {
        this.setState({
            form: {
                code: this.props.match.params.code,
            }
        });
    }

    handleSetPw = e => {
        e.preventDefault();
        const {form} = this.state;
        if (form.newpass !== form.confirm) {
            this.setState({validDifPass: true});
        } else {
            if (this.state.validPass) {
                Auth.forgotPasswordSubmit(form.login, form.code, form.newpass)
                    .then(data => {
                        this.setState({
                            validPass: true,
                            validDifPass: false,
                            setPassword: false,
                            invalidPassorUser: false,
                            successNewPass: true,
                            user: null,
                            isLoading: false,
                        });
                        this.setState(prevState => ({
                            form: {...prevState.form, ['pass']: form.newpass}
                        }));
                    })
                    .catch(err => {
                        console.log(err);
                        LogRocket.captureException(err);
                        swal("", err.message, "info");
                    });

                //swal("", data.login.alerts.new_pass, "success");
            }
        }
    };

    handleChange = e => {
        e.preventDefault();
        const {name, value} = e.target;
        this.setState(prevState => ({
            form: {...prevState.form, [name]: value}
        }));
    };

    handleKeyUp = e => {
        e.preventDefault();
        const {name, value} = e.target;
        this.setState({validPass: reg.test(value)});
    };


    login = async (login, pass) => {
        try {
            const user = await Auth.signIn(login, pass);
            return user;
        } catch (error) {
            console.log('error signing in', error);
        }
        //do stuff
    };

    handleLogin = async (e) => {
        this.setState({isLoading: true});
        e.preventDefault();
        const {form} = this.state;
        if (form.login && form.pass) {
            const user = this.login(form.login, form.pass);
            user.then(user => {
                if (user?.challengeName === 'NEW_PASSWORD_REQUIRED') {
                    this.setState({setPassword: true, user});
                } else if (user) {

                    LogRocket.identify(user.username, {
                        name: user.attributes.email,
                        email: user.attributes.email,
                        SISTEMA: process.env.REACT_APP_NAME,
                        'SISTEMA-TENANT_ID': process.env.REACT_APP_X_TENANT_ID,
                    });

                    const token = user.signInUserSession.idToken.jwtToken;
                    const email = user.attributes.email;
                    const name = user.username;
                    localStorage.setItem('tbClientes', email);
                    localStorage.setItem('token', token);
                    localStorage.setItem('nameSession', name);

                    const user_details = this.props.getUser();
                    user_details.then(user_d => {
                        // alert(localStorage.getItem("typePermission"));


                        if (localStorage.getItem("typePermission") === "") {
                            alert("CONTATE SEU ADMIN");
                        } else if (localStorage.getItem("typePermission") === "SYSTEM ADMIN") {

                            const userdash = this.props.getDashUser();
                            userdash.then(userdash => {
                                let dashs = JSON.parse(localStorage.getItem('dashboards'));
                                localStorage.setItem('urlStandard','/ij/painel/' + dashs[0].dashboardId);
                                this.props.history.push('/ij/painel/' + dashs[0].dashboardId);
                            })

                        } else if (localStorage.getItem("typePermission") === "USER ADMIN") {
                            localStorage.setItem('urlStandard', '/user/config/');
                            this.props.history.push('/user/config/');
                        } else if (localStorage.getItem("typePermission") === "USER EXPLORER") {
                            localStorage.setItem('urlStandard','/ij/explorer');
                            this.props.history.push('/ij/explorer');
                        } else if (localStorage.getItem("typePermission") === "USER BRONZE") {
                            localStorage.setItem('urlStandard', '/captura/manual');
                            this.props.history.push('/captura/manual');
                        } else if (localStorage.getItem("typePermission") === "USER SILVER") {
                            localStorage.setItem('urlStandard', '/captura/manual');
                            this.props.history.push('/captura/manual');
                        } else if (localStorage.getItem("typePermission") === "USER GOLD") {
                            const userdash = this.props.getDashUser();
                            userdash.then(userdash => {
                                let dashs = JSON.parse(localStorage.getItem('dashboards'));
                                localStorage.setItem('urlStandard', '/ij/painel/' + dashs[0].dashboardId);
                                this.props.history.push('/ij/painel/' + dashs[0].dashboardId);
                            })

                        }


                    })

                } else {

                    this.setState({isLoading: false, invalidPassorUser: true});
                    //alert('Login ou senha Incorretos!');

                    //swal("", data.login.alerts.incorrect, "info");

                }
            });
        } else {
            this.setState({isLoading: false});
            //alert('Login e senha Obrigatórios!');
            swal("", data.login.alerts.mandatory, "info");
        }
    };


    render() {
        let {form} = this.state;
        //const {isLoading} = this.state;
        if (!process.env.REACT_APP_BG_COLOR_CLIENT1) {
            bgStyle = process.env.REACT_APP_SYSTEM === "nxtoperations" ? {background: "transparent linear-gradient(180deg, #002D9B 0%, #37D996 100%) 0% 0% no-repeat padding-box"} : {background: "transparent linear-gradient(180deg, #002D9B 0%, #0F61FD 100%) 0% 0% no-repeat padding-box"};
        }

        return (<>
            {process.env.REACT_APP_SRC_IMG_CLIENT ? ("") : (<div className="login-container">
                <K_SVG className="vector-k"/>
            </div>)
            }
            {this.state.successNewPass && (
                <ComposedModal size="xs" open>
                    <ModalHeader title="Alert"/>
                    <ModalBody>
                        {data.login.alerts.success_change}
                    </ModalBody>
                    <ModalFooter onRequestSubmit={this.handleLogin} primaryButtonText="Login"></ModalFooter>
                </ComposedModal>
            )}
            <Grid
                style={bgStyle}
                fullWidth>
                <div className="DR-logo">
                    <img src={process.env.REACT_APP_SRC_IMG_CLIENT ? process.env.REACT_APP_SRC_IMG_CLIENT :
                        require("./assets/Logo-Bandeira-DR-2020.png")} alt="logo"/>
                    <p>{this.props.name}</p>
                </div>
                <Row>
                    <Column
                        className={process.env.REACT_APP_SRC_IMG_CLIENT ? "login-form login-65" : "login-form login-50"}>
                        <form className="new-pass" onSubmit={null}>
                            <FormGroup legendText="">
                                <p className="p-title">
                                    {data.login.text_change_pass_code}
                                </p>
                                <TextInput
                                    type="email"
                                    required
                                    pattern=""
                                    id="login"
                                    name="login"
                                    labelText=""
                                    onChange={this.handleChange}
                                    placeholder={data.login.email}
                                    value={form.login}
                                    light
                                />
                                <br/>
                                <br/>
                                <br/>
                                <TextInput
                                    //required
                                    pattern=""
                                    id="code"
                                    name="code"
                                    autocomplete="off"
                                    helperText=""
                                    onChange={this.handleChange}
                                    onKeyUp={this.handleKeyUp}
                                    labelText=""
                                    placeholder={data.login.code}
                                    value={form.code}
                                    light
                                />
                                <br/>
                                <br/>
                                <br/>
                                <TextInput.PasswordInput
                                    //required
                                    pattern=""
                                    id="newpass"
                                    name="newpass"
                                    autocomplete="off"
                                    helperText="Your password must be at least 8 characters with at least 1 uppercase letter and 1 special character."
                                    invalidText="Your password must be at least 8 characters with at least 1 uppercase letter and 1 special character."
                                    onChange={this.handleChange}
                                    onKeyUp={this.handleKeyUp}
                                    labelText=""
                                    placeholder={data.login.new_pass}
                                    value={form.newpass}
                                    light
                                    invalid={!this.state.validPass}
                                />
                                <br/>
                                <br/>
                                <br/>
                                <TextInput.PasswordInput
                                    //required
                                    pattern=""
                                    id="confirm"
                                    name="confirm"
                                    autocomplete="off"
                                    onChange={this.handleChange}
                                    labelText=""
                                    invalidText={data.login.alerts.pass_diferent}
                                    placeholder={data.login.new_pass_confirm}
                                    value={form.confirm}
                                    light
                                    invalid={this.state.validDifPass}
                                />
                                <br/>
                                <br/>
                                <Button
                                    className="btn-new-pass"
                                    kind='tertiary'
                                    renderIcon={ChevronRight24}
                                    iconDescription={data.login.submit_new_pass}
                                    type="button"
                                    onClick={this.handleSetPw}
                                >
                                    {data.login.submit_new_pass}
                                </Button>
                            </FormGroup>
                        </form>
                        {process.env.REACT_APP_SRC_IMG_CLIENT ? (
                                <img style={{width: "200px", position: "absolute", bottom: "50px", margin: "0 2.1rem"}}
                                     src={require("./assets/DRpoweredby.png")} alt="logo"/>) :
                            ("")}
                    </Column>
                    <Column lg={2}></Column>
                </Row>
            </Grid>
        </>);

    }
}

const mapStateToProps = ({users}) => users;

const mapDispatchToProps = dispatch => ({
    getDashUser: () => dispatch(dash_action_logged())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Recovery);
